import { render, staticRenderFns } from "./WorkItems.vue?vue&type=template&id=99b11508&"
import script from "./WorkItems.vue?vue&type=script&lang=js&"
export * from "./WorkItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports